import { Configuration, TupvidApi } from '@ibe/tupvid-api';
import { removeTrailingSlashes } from '@ibe/services';
import { useConfiguration, useAuthenticate } from '@ibe/tupvid-components';

function useTupvidApi(): TupvidApi {
  const configService = useConfiguration();
  const { authenticateService } = useAuthenticate();
  return new TupvidApi(
    new Configuration({
      basePath: removeTrailingSlashes(configService.configuration.apiUrl),
      apiKey: authenticateService.state.token || undefined,
      headers: {
        'Accept-Language': configService.lang
      }
    })
  );
}

export default useTupvidApi;
